import {Modal} from "@common/Modal";
import i18n from "@service/locale/i18";

export const showCantShareMessage = () => {
    const modalWindow = new Modal({
        title: i18n.t('web-conferences.errors.cantShare.title').toString(),
        contentText: i18n.t('web-conferences.errors.cantShare.text').toString(),
        buttons: [
            {
                text: 'Ok',
                class: 'is-green',
                returnValue: true
            }
        ]
    });
    modalWindow.showModal();
}

export const showCantJoinShareMessage = () => {
    const modalWindow = new Modal({
        title: i18n.t('web-conferences.errors.cantJoinShare.title').toString(),
        contentText: i18n.t('web-conferences.errors.cantJoinShare.text').toString(),
        buttons: [
            {
                text: 'Ok',
                class: 'is-green',
                returnValue: true
            }
        ]
    });
    modalWindow.showModal();
}
